import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the getMove method.
 */
export function createGetMove(context: API.Context) {
  /**
   * Get a move object from a move attempt.
   */
  return function getMove(mv: JCE.AnyMoveType): Game.Move.Model | null {
    const { game } = context;

    if (mv.to === null) {
      return null;
    }

    let m = game.getMove(mv);

    if (m === null) {
      (<any>Object).assign(mv, { promotion: 'q' });

      m = game.getMove(mv);
    }

    if (m) {
      m = game.moveDetails(m);
    }

    return m;
  };
}
